import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { AppModalDto } from "../../core/dto/generic.dto";

const AppModal = ({
    title,
    bodyText,
    primaryButtonLabel,
    secondaryButtonLabel,
    primaryButtonEventEmitter,
    secondaryButtonEventEmitter
}: AppModalDto) => {
    const [show, setShow] = React.useState(false);

    const handleClose = React.useCallback(() => {
        setShow(false);
        if (primaryButtonEventEmitter) {
            primaryButtonEventEmitter();
        }
    }, []);

    const handleSecondaryButtonClose = React.useCallback(() => {
        setShow(false);
        if (secondaryButtonEventEmitter) {
            secondaryButtonEventEmitter();
        }
    }, []);

    React.useEffect(() => {
        setShow(true);
        return () => {
            setShow(false);
        };
    }, []);

    return (
        <Modal show={show} size="lg">
            <Modal.Header>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {bodyText}
            </Modal.Body>
            <Modal.Footer>
                {primaryButtonLabel && (
                    <Button
                        variant="primary"
                        onClick={handleClose}
                    >
                        {primaryButtonLabel}
                    </Button>
                )}
                {secondaryButtonLabel && (
                    <Button
                        variant="secondary"
                        onClick={handleSecondaryButtonClose}
                    >
                        {secondaryButtonLabel}
                    </Button>
                )}
            </Modal.Footer>
        </Modal>
    );
};

export default AppModal;
